/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import LoadPanel from "devextreme-react/load-panel";
import { useSelector, useDispatch } from "react-redux";
import { responseMiddleware } from "../../../redux/reducers";
import { IsPermisionOidRequired } from "../../../redux/actions";
import "./style.scss";
import TransactionAdjustmentDataTableList from "./TransactionAdjustmentDataTable";
import UsingIntl from "../../../services/using_intl";
import { formatMessage } from "devextreme/localization";

export default function TransactionAdjustmentDataList() {
  let dataGrid = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { middleware, loading } = useSelector(responseMiddleware);

  useEffect(() => {
    UsingIntl();
    dispatch(IsPermisionOidRequired());
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);

  return (
    <div>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("TransactionAdjustmentData")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/transaction-adjustment/list" className={"breadcrumb-item"}>
            {formatMessage("TransactionAdjustment")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("TransactionAdjustmentData")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <TransactionAdjustmentDataTableList
            dataGrid={dataGrid}
            middleware={middleware}
          />
        </div>
      </div>
    </div>
  );
}
